import React, { useEffect, useState } from 'react';
import { KTSVG, KTIcon, toAbsoluteUrl } from '../../_metronic/helpers';
import fetchAPI from '../../common/fetchAPI';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { formatDateWithDateAndMonthName, getValueFromResource,formatDateWithTZ } from '../../common/timeLiveFunction';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
const initialValues = {
    timeOffRequestDetailList: [],
    submittedBy: '',
    submittedOn: '',
    accountTimeOffType: ''
}

const TimeOffRequestDetail = (props: any) => {
    const [timeOffRequestDetail, setTimeOffRequestDetail] = useState<any | ''>(initialValues);
    const { decimalPlaces, cultureInfoName,ProfileTimeZoneIANA } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (props.accountEmployeeTimeOffRequestId) {
            props.accountEmployeeTimeOffRequestId != '' && getTimeOffRequestOfDetail(props.accountEmployeeTimeOffRequestId);
        }
    }, [props.accountEmployeeTimeOffRequestId])

    const getTimeOffRequestOfDetail = async (id: string) => {
        const response = await fetchAPI(`api/Timeoff/GetByTimeOffRequestId/${id}/`, 'Get', '', true);
        const json = await response.json();
        console.log('setTimeOffRequestDetail',json)
        setTimeOffRequestDetail({
            ...timeOffRequestDetail,
            timeOffRequestDetailList: json[0].hasOwnProperty("Message") != true ? json : [],
            submittedBy: json[0].EmployeeCode?.trim() ? `${json[0].EmployeeCode.trim()} - ${json[0].FullName}` : json[0].FullName,
            submittedOn: moment(json[0].CreatedOn).format('YYYY-MM-DD'),
            accountTimeOffType: json[0].AccountTimeOffType
        });
    }

    return (
        <div className='modal drawer-overlay' id='timeOffRequestDetailModal' aria-hidden='true' data-bs-backdrop="false">
            <div className='modal-dialog modal-xl'>
                <div className='modal-content rounded'>
                    {/* <div className="modal-header"> */}
                    {/* <h5> */}
                    {/* {t('Time Off Request Approval Detail')} */}
                    {/* {getValueFromResource('Time Off Request Approval Detail',dispatch, t)} */}
                    {/* </h5> */}
                    {/* <div */}
                    {/* className="btn btn-icon btn-sm btn-active-light-primary ms-2" */}
                    {/* data-bs-dismiss="modal" */}
                    {/* aria-label="Close" */}
                    {/* > */}
                    {/* <KTSVG */}
                    {/* path="/media/icons/duotune/arrows/arr061.svg" */}
                    {/* className="svg-icon svg-icon-2x" */}
                    {/* /> */}
                    {/* </div> */}
                    {/* </div> */}
                    <div className='modal-header pb-2'>
                        <h5>
                            {/* {`Attachment`} */}
                            {getValueFromResource('Time Off Request Approval Detail', dispatch, t)}

                        </h5>
                        <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' aria-label="Close">
                            <KTIcon iconName='cross' className='fs-1' />
                        </div>
                    </div>
                    <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                        {timeOffRequestDetail.timeOffRequestDetailList.length > 0 && <>
                             <div className="table">
                            <table className="table" >
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'center' }}>
                                            <div className='hdApprovalDetail'>
                                                <div className='symbol symbol-36px me-2'>
                                                    <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Employee.svg')} />
                                                </div>
                                                <div style={{ textAlign: 'left', marginLeft: '6px' }}>
                                                    <div>
                                                        {/* {t('Submitted By')} */}
                                                        {getValueFromResource('Submitted By', dispatch, t)}
                                                    </div>
                                                    <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{timeOffRequestDetail.submittedBy}</div>
                                                </div>
                                            </div>
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                            <div className='hdApprovalDetail'>
                                                <div className='symbol symbol-36px me-2'>
                                                    <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Date.svg')} />
                                                </div>
                                                <div style={{ textAlign: 'left', marginLeft: '6px' }}>
                                                    <div>
                                                        {/* {t('Submitted On')} */}
                                                        {getValueFromResource('Submitted On', dispatch, t)}

                                                    </div>
                                                    <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{
                                                    // formatDateWithDateAndMonthName(timeOffRequestDetail.submittedOn, cultureInfoName.toString())
                                                    formatDateWithTZ(moment.parseZone(timeOffRequestDetail.submittedOn).format("YYYY-MM-DD"), cultureInfoName.toString(),ProfileTimeZoneIANA)
                                                    }</div>
                                                    {/* <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{timeOffRequestDetail.submittedOn}</div> */}
                                                </div>
                                            </div>
                                        </th>
                                        <th style={{ textAlign: 'center' }}>
                                            <div className='hdApprovalDetail'>
                                                <div className='symbol symbol-36px me-2'>
                                                    <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Clock.svg')} />
                                                </div>
                                                <div style={{ textAlign: 'left', marginLeft: '6px' }}>
                                                    <div>
                                                        {/* {t('Time Off Type')} */}
                                                        {getValueFromResource('Time Off Type', dispatch, t)}

                                                    </div>
                                                    <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{timeOffRequestDetail.accountTimeOffType}</div>
                                                </div>
                                            </div>
                                        </th>

                                    </tr>
                                </thead>

                            </table>

                        </div>
                        <div className="custom-separator"></div>
                        </>
                        }
                        <div className="table-responsive">
                            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1"  >
                                <thead>
                                    <tr className="tbheading align-middle">
                                        <th className='w-25' style={{ paddingLeft: '10px' }}>
                                            {/* {t(`Approver Name`)} */}
                                            {getValueFromResource('Approver Name', dispatch, t)}
                                        </th>
                                        <th className='w-25'>
                                            {/* {t(`Approved On`)} */}
                                             {getValueFromResource('Activity Date', dispatch, t)}
                                        </th>
                                        <th className='w-25'>
                                            {/* {t(`Status`)} */}

                                            {getValueFromResource('Status', dispatch, t)}
                                        </th>
                                        <th className='w-25'>
                                            {/* {t(`Comments`)} */}

                                            {getValueFromResource('Comments', dispatch, t)}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {timeOffRequestDetail.timeOffRequestDetailList.length > 0 && timeOffRequestDetail.timeOffRequestDetailList.map((item: any, index: number) => {
                                        return (
                                            <tr key={index} style={{ height: 42, marginLeft: '15px', marginRight: '-15px' }}>
                                                <td style={{ paddingLeft: 10 }}>{item.ApproverName}</td>
                                                <td>{item.IsApproved ? 
                                                // formatDateWithDateAndMonthName(item.ApprovedOnApproval, cultureInfoName.toString()) 
                                                formatDateWithTZ(moment.parseZone(item.ApprovedOnApproval).format("YYYY-MM-DD"), cultureInfoName.toString(),ProfileTimeZoneIANA)
                                                : 
                                                // formatDateWithDateAndMonthName(item.RequestSubmitDate, cultureInfoName.toString())
                                                formatDateWithTZ(moment.parseZone(item.RequestSubmitDate).format("YYYY-MM-DD"), cultureInfoName.toString(),ProfileTimeZoneIANA)
                                                }
                                                </td>
                                                <td>
                                                    {item.IsApproved ?
                                                        <span className='app-navbar-item badge badge-light-success' style={{ fontWeight: '600', lineHeight: '1.2', justifyContent: 'center' }}>
                                                            {/* {t('Approved')} */}
                                                            {getValueFromResource('Approved', dispatch, t)}

                                                        </span> :
                                                        <span className='app-navbar-item badge badge-light-danger' style={{ fontWeight: '600', lineHeight: '1.2', justifyContent: 'center' }}>
                                                            {/* {t('Rejected')} */}
                                                            {getValueFromResource('Rejected', dispatch, t)}

                                                        </span>}
                                                </td>
                                                <td>{item.Comments}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            {timeOffRequestDetail.timeOffRequestDetailList.length === 0 &&
                                <div className=''><p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}

                                </p>
                                </div>
                            }
                        </div>

                    </div>
                    <div className="modal-footer"  >
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            data-bs-dismiss="modal"
                        >
                            {/* {t('Cancel')} */}
                            {getValueFromResource('Cancel', dispatch, t)}

                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TimeOffRequestDetail